import {AppIconButton} from 'components/buttons';
import MultiChipAutoCompleteBase from 'components/form/Select/AutoComplete/MultiChipAutoCompleteBase';
import {Send2} from 'iconsax-react';
import React, {useState} from 'react';

interface UserInvitationFieldProps {
    searchValue: string;
    setSearchValue: (value: string) => void;
    inviteSubmitHandler: (values: string[]) => void;
    loading?: boolean;
}

export const UserInvitationField: React.FC<UserInvitationFieldProps> = ({
    searchValue,
    loading = false,
    setSearchValue,
    inviteSubmitHandler,
}) => {
    const [selectedValues, setSelectedValues] = useState<string[]>([]);

    const isValidEmail = (email: string) =>
        /^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9\-.]+)\.([a-zA-Z]{2,})$/.test(email.trim());

    const handleUserInvite = () => {
        const validEmails = selectedValues.filter(isValidEmail);
        inviteSubmitHandler(validEmails);
        setSelectedValues([]);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && searchValue.trim()) {
            event.preventDefault();
            if (!selectedValues.includes(searchValue) && isValidEmail(searchValue)) {
                setSelectedValues([...selectedValues, searchValue.trim()]);
            }
            setSearchValue('');
        }
    };

    return (
        <>
            <MultiChipAutoCompleteBase
                options={[]}
                value={selectedValues}
                onChange={(_, newValue) => setSelectedValues((newValue as string[]).filter(isValidEmail))}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onKeyDown={handleKeyDown}
                validRegex={/^([a-zA-Z0-9_\-.+]+)@([a-zA-Z0-9\-.]+)\.([a-zA-Z]{2,})$/}
                placeholder="Invite Users"
            />
            <AppIconButton
                color="primary"
                sx={{border: '1px solid', ml: 1}}
                isLoading={loading}
                disabled={selectedValues.filter(isValidEmail).length === 0 || loading}
                onClick={handleUserInvite}
            >
                <Send2 variant="Outline" />
            </AppIconButton>
        </>
    );
};

export default UserInvitationField;
